/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getSession, setSession } from "~/lib/helperFuncation/sessionStorageService";
import { VIDEO_PLAYER } from "~/utils/constant";
import { isIOS } from "~/utils/helper-funcations";

export interface videoDataType {
  videoId: string;
  id?: number;
  from?: string;
  name?: string | null;
  duration?: number | null;
  thumbnailUrl?: string | null;
}

interface youTubePlayerType {
  isVideoPlay: boolean;
  videoSeekPosition: number;
  currentVideoId: string | null;
  currentVideo: videoDataType | null;
  currentVideoPosition: number;
  videoQueue: videoDataType[];
  youtubeVideoIsPlay: boolean;
  isFullScreen: boolean;
  isMute: boolean;
  pipMode?: boolean;
  isPlaylist: boolean;
  playAllAudioInPlaylist?: boolean;
  showThumbnail: boolean;
}

interface InitialState extends youTubePlayerType {}

const initialState: InitialState = {
  isVideoPlay: JSON.parse(getSession(VIDEO_PLAYER.IS_VIDEO_PLAY) || "false") || false,
  videoSeekPosition: 0,
  currentVideoId: null,
  currentVideo: null,
  currentVideoPosition: 0,
  videoQueue: typeof window !== "undefined" ? (getSession(VIDEO_PLAYER.VIDEO_QUEUE) as videoDataType[]) || [] : [],
  youtubeVideoIsPlay: true,
  isFullScreen: false,
  isMute: isIOS() || false,
  pipMode: JSON.parse(getSession(VIDEO_PLAYER.PIP_MODE) || "false") || false,
  isPlaylist: false,
  playAllAudioInPlaylist: true,
  showThumbnail: true,
};

export const youtubeSlice = createSlice({
  name: "youtube",
  initialState,
  reducers: {
    onPlayVideo: (state, action: PayloadAction<string | null>) => {
      state.isVideoPlay = true;
      state.showThumbnail = false;
      sessionStorage.setItem(VIDEO_PLAYER.IS_VIDEO_PLAY, JSON.stringify(true));
    },
    onPauseVideo: (state) => {
      state.isVideoPlay = false;
      // state.showThumbnail = true;
      setSession(VIDEO_PLAYER.IS_VIDEO_PLAY, JSON.stringify(false));
    },
    setVideoSeekPosition: (state, action: PayloadAction<number>) => {
      state.videoSeekPosition = action.payload;
    },
    setCurrentVideoId: (state, action: PayloadAction<string | null>) => {
      // If a video is already playing and we're setting a different video ID,
      // pause the current video first
      if (state.isVideoPlay && state.currentVideoId && action.payload && state.currentVideoId !== action.payload) {
        state.isVideoPlay = false;
        if (typeof window !== "undefined") {
          sessionStorage.setItem(VIDEO_PLAYER.IS_VIDEO_PLAY, JSON.stringify(false));
        }
      }
      state.currentVideoId = action.payload;
    },
    setCurrentVideo: (state, action: PayloadAction<videoDataType | null>) => {
      if (action.payload?.videoId) {
        // If a video is already playing and we're setting a different video,
        // pause the current video first
        // if (state.isVideoPlay && state.currentVideoId && action.payload.videoId !== state.currentVideoId) {
        //   console.log("Setting current video to: ", action.payload.videoId);
        //   state.isVideoPlay = false;
        //   if (typeof window !== "undefined") {
        //     sessionStorage.setItem(VIDEO_PLAYER.IS_VIDEO_PLAY, JSON.stringify(false));
        //   }
        // }

        if (action.payload) {
          state.currentVideoId = action.payload.videoId;
        }
        state.currentVideo = action.payload;
        if (typeof window !== "undefined") {
          sessionStorage.setItem(VIDEO_PLAYER.CURRENT_VIDEO, JSON.stringify(action.payload));
        }
      } else {
        state.currentVideo = null;
        state.currentVideoId = null;
      }
    },
    setCurrentVideoPosition: (state, action: PayloadAction<number>) => {
      state.currentVideoPosition = action.payload;
      if (typeof window !== "undefined") {
        sessionStorage.setItem(VIDEO_PLAYER.CURRENT_VIDEO_POSITION, JSON.stringify(action.payload));
      }
    },
    setVideoQueue: (state, action: PayloadAction<videoDataType[]>) => {
      state.videoQueue = action.payload;
      if (typeof window !== "undefined") {
        sessionStorage.setItem(VIDEO_PLAYER.VIDEO_QUEUE, JSON.stringify(action.payload));
      }
    },
    addVideoToQueue: (state, action: PayloadAction<videoDataType>) => {
      state.videoQueue.push(action.payload);
      if (typeof window !== "undefined") {
        sessionStorage.setItem(VIDEO_PLAYER.VIDEO_QUEUE, JSON.stringify(state.videoQueue));
      }
    },
    setYoutubeVideoIsPlay: (state, action: PayloadAction<boolean>) => {
      state.youtubeVideoIsPlay = action.payload;
      if (typeof window !== "undefined") {
        sessionStorage.setItem(VIDEO_PLAYER.YOUTUBE_VIDEO_IS_PLAY, JSON.stringify(action.payload));
      }
    },
    setFullScreen: (state, action: PayloadAction<boolean>) => {
      state.isFullScreen = action.payload;
    },
    setIsMute: (state, action: PayloadAction<boolean>) => {
      state.isMute = action.payload;
    },
    setPipMode: (state, action: PayloadAction<boolean>) => {
      const value = action.payload;
      state.pipMode = value;
      setSession(VIDEO_PLAYER.PIP_MODE, JSON.stringify(value));
    },
    setPlaylist: (state, action: PayloadAction<boolean>) => {
      state.isPlaylist = action.payload;
    },
    setPlayAllAudioInPlaylist: (state, action: PayloadAction<boolean>) => {
      state.playAllAudioInPlaylist = action.payload;
    },
    setShowThumbnail: (state, action: PayloadAction<boolean>) => {
      state.showThumbnail = action.payload;
      // state.isVideoPlay = !action.payload;
    },
  },
});

export const {
  onPlayVideo,
  onPauseVideo,
  setVideoSeekPosition,
  setCurrentVideoId,
  setCurrentVideo,
  setCurrentVideoPosition,
  setVideoQueue,
  addVideoToQueue,
  setYoutubeVideoIsPlay,
  setFullScreen,
  setIsMute,
  setPipMode,
  setPlaylist,
  setPlayAllAudioInPlaylist,
  setShowThumbnail,
} = youtubeSlice.actions;

export default youtubeSlice.reducer;
